import React, { Fragment } from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

const EmptyCartContent = () => {
    const { t } = useGranite();
    return (
        <div className="px-3">
            <div className="heading-5 bg-light-gray py-1 px-2 mb-0">
                {t("general.miniCart.empty.title")}
            </div>
            <p className="small py-2">{t("general.miniCart.empty.message")}</p>
            <div className="text-center">
                <i
                    className="las la-cart-plus text-light-gray"
                    style={{ fontSize: "5em" }}
                />
            </div>
        </div>
    );
};

export default EmptyCartContent;
